import { render, staticRenderFns } from "./pic.vue?vue&type=template&id=d2fd27ae"
import script from "./pic.vue?vue&type=script&lang=js"
export * from "./pic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports